export default class Events {
    public static TokenUpdated = "TokenUpdated";
    public static ValidityUpdated = "ValidityUpdated";
    public static DonationSubmitted = "DonationSubmitted";
    public static CardholderNameUpdated = "CardholderNameUpdated";
    public static SubmitPaymentClicked = "SubmitPaymentClicked";
    public static RefreshToken = "RefreshToken";
}
